export const connectContract = (web3, contractAbi, contractAddress) => {
  return new web3.eth.Contract(contractAbi, contractAddress);
};
